import React from "react";
import { createRoot } from 'react-dom/client';
import App from "../components/News/App";

/**
 * News Index
 */

const PageNewsIndex = ($) => {
	if (
		$("body").hasClass("page-template-news-index")
	) {
		const newsIndex = document.getElementById("js-news-index");

		let props = {
			...(newsIndex && newsIndex.dataset),
		};

		const root = createRoot(newsIndex);
		root.render(<App {...props}/>);
	}
};

export default PageNewsIndex;
